<template>
  <page :title="title" :breadcrumb="breadcrumb">
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              More Links...
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
      <div class="actionBlock" v-if="!newGLAcctNo">
        <v-btn text color="secondary" v-on="on" @click="info = !info">
          Overview
          <v-icon right>mdi-file-document-box</v-icon>
        </v-btn>
      </div>
    </div>
    <v-navigation-drawer temporary clipped fixed right hide-overlay v-model="info" width="400">
      <gl-acct-no-info :updateCnt="$store.state.glAcctParam.glAcctNo.updateCnt"></gl-acct-no-info>
    </v-navigation-drawer>
    <v-card>
      <!-- <v-card-title>
        <span class="title" v-if="newGLAcctNo">New GL Account No.</span>
        <span class="title" v-else>{{glacctNoId.branch}} {{glacctNoId.glacctNo}} {{glacctNoId.fund}} {{glacctNoId.acctNoSfx}}</span>
      </v-card-title> -->
      <transition name="slide-x-transition" mode="out-in">
        <router-view></router-view>
      </transition>
    </v-card>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'
import GlAcctNoInfo from '../GLAcctNoInfo'
export default {
  data() {
    return {
      title: 'GL Account No',
      breadcrumb: [],
      sideMenu: [
        { name: 'glAcctNoDet', text: 'GL Account No.' },
        { name: 'glPostAcct', text: 'GL Ledger' },
        { name: 'glBudget', text: 'GL Budget' }
      ],
      sideFunction: [
        {
          text: 'GL Account No.',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: { name: 'glAcctNoDet' }
        },
        {
          text: 'GL Ledger',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: { name: 'glPostAcct' }
        }
        // {
        //   text: 'GL Budget',
        //   icon: 'mdi-launch',
        //   iconColor: 'primary',
        //   params: { name: 'glBudget' }
        // }
      ],
      info: false
    }
  },
  created() {
    this.breadcrumb = this.derieveBreadcrumbByName('glAcctNoList')
    this.breadcrumb.push({
      text: this.title
    })
  },
  mounted() {
    this.doInit()
  },
  methods: {
    doInit() {}
  },
  computed: {
    ...mapGetters(['derieveBreadcrumbByName']),
    menu() {
      return this.$store.state.glAcctParam.menu
    },
    glacctNoId() {
      return this.$store.state.glAcctParam.glAcctNo.glAcctNoId
    },
    newGLAcctNo() {
      return this.glacctNoId.branch === 'new' && this.glacctNoId.glacctNo === 'new'
    }
  },
  components: {
    SideFunctionMenu,
    GlAcctNoInfo
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/base.scss';
.queryPnl {
  margin-top: 50px;
}
</style>
